import { wsLogger } from '@/shared/lib/logger';
import { queryClient } from '@/shared/lib/query-client';
import { cacheKeys } from '@/shared/lib/cache-invalidation';
import type {
  DataChangedEvent,
  LoadingFactsReadyPayload,
} from '../realtime-sync.types';

export async function handleLoadingFactsReady(event: DataChangedEvent): Promise<void> {
  const payload = event.payload as LoadingFactsReadyPayload | undefined;
  if (!payload?.facts || !payload.project_id) return;

  wsLogger.info('[RealtimeSync] Loading facts ready:', {
    projectId: payload.project_id,
    factsCount: payload.facts.length,
  });

  // Populate TanStack Query cache for all locales matching this projectId
  queryClient.setQueriesData(
    { queryKey: cacheKeys.loadingFacts.byProject(payload.project_id) },
    { facts: payload.facts, is_contextual: payload.is_contextual }
  );
}
